<template>
    <div>
      <!-- <v-toolbar flat color="primary">
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text" >
          Information
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar> -->
      <v-list dense>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="goAction(item.action)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
    </div>
</template>
<script>
export default {
    props:[
      'group_id',
      'currentLocale'
    ],
    data: () => ({
      account_id: 1,
      header:[],
      items: [
        { title: 'Feed', action: 'feed', need_login: false, icon: 'mdi-newspaper', route: '/' },
        { title: 'Achievements', action: 'achievements', need_login: false, icon: 'mdi-trophy', route: '/achievements' },
        { title: 'Ranking', action: 'ranking', need_login: false, icon: 'mdi-chart-bar', route: '/ranking' },
        { title: 'Deathlog', action: 'deathlog',need_login: false, icon: 'mdi-skull',  route: "/deathlog" },
        { title: 'Guilds', action: 'guilds', need_login: false, icon: 'mdi-account-group', route: '/guilds' },
        { title: 'Profile', action: 'profile', need_login: false, icon: 'mdi-account', route: '/profile' },
        { title: 'Market', action: 'market', need_login: false, icon: 'mdi-storefront', route: '/market' },
        { title: 'Shop', action: 'shop', need_login: false, icon: 'mdi-cart', route: '/cashshop' },
      ],
    }),
    mounted() {
    },
    methods: {
      goAction(value){
        switch(value){
          case 'feed': this.$router.push('/'); break;
          case 'Achievements': this.$router.push('/achievements'); break;
          case 'ranking': this.$router.push('/ranking'); break;
          case 'deathlog': this.$router.push('/deathlog'); break;
          case 'guilds': this.$router.push('/guilds'); break;
          case 'profile': this.$router.push('/profile'); break;
          case 'shop': this.$router.push('/cashshop'); break;
          case 'market': this.$router.push('/market'); break;
          
          case 'showFAQ': /*this.$emit('loginregister');*/ break;
          case 'showWiki': window.open('https://wiki.mmo-age.com/', '_blank'); break;
          case 'showWoE': this.$router.push('/woe'); break;
          case 'showMln': this.$router.push('/multilevel'); break;
        }
      },
    },
    watch: {
    },
};
</script>